import React from 'react';
import { createRoot } from 'react-dom/client';
import { clientIdentification } from '@gjensidige/service-client-identification';
import { remoteLogWindowOnError } from '@gjensidige/service-error-handler';

import { CUSTOMER_SEGMENT } from './constants';
import BranchPicker from './components/BranchPicker';
import Navigation from './components/Navigation';

clientIdentification.configure({
  clientId: `${process.env.CLIENT_NAME}-${CUSTOMER_SEGMENT}`,
  clientVersion: process.env.CLIENT_VERSION
});

window.onerror = remoteLogWindowOnError;

const branchPickerElement = document.getElementById('branch-picker');

if (branchPickerElement) {
  const branchPicker = createRoot(branchPickerElement);
  if (window.branches?.length && ['local', 'dev', 'test'].includes(window.environment)) {
    branchPicker.render(<BranchPicker branches={window.branches} />);
  }
}

// window.isNciNavigationOnly = true;

const navigationElement = document.getElementById('application-portal');
if (navigationElement) {
  const navigation = createRoot(navigationElement);
  navigation.render(<Navigation />);
}
